// src/components/Footer.js
import React from 'react';

const Footer = () => {

    // Vérifie si l'application est chargée dans une iframe
    const isInIframe = window.self !== window.top;

    // Si l'application est dans une iframe, ne pas afficher le footer
    if (isInIframe) {
        return null;
    }
    return (
        <footer className='footer'>
            <p>&copy; Données produites par l'IGN dans le cadre du programme national LiDAR HD. © IGN - 2024.</p>
        </footer>
    );
};


export default Footer;
